// ============================================================
// セルフ対応できる拠点の一覧（承認済みモック self-spots の移植・顧客向け表現）
// 一覧は静的データ（selfGuideData.SELF_SPOTS）。顧客向けの拠点一覧APIが
// 無いため、本番設定値のスナップショットを保持する。設定変更時は要更新。
// 海神クリーニングは船堀店のみ店頭でセルフ対応（2026-10-08〜）。瑞江店はセルフ未対応。
// ============================================================
import { IoChevronBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { Analytics } from '../../compornents/Analytics';
import { SELF_SPOTS, navUrl } from './selfGuideData';
import '../../css/SelfGuide.css';

export const SelfSpots = () => {
  const navigate = useNavigate();
  const back = () => navigate(-1);

  const typeLabel = (s) => {
    if (s.type === 'locker') return <span className="sg-ok">○ ロッカー<small>24時間ご利用可能</small></span>;
    return <span className="sg-ok">○ 店頭のみ{s.hours && <small>{s.hours}</small>}</span>;
  };

  return (
    <div className="App">
      <div className="SelfGuide">
        <Analytics title="セルフ対応できる拠点" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back}>
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            セルフ対応できる拠点
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="sg-body">
          <div className="sg-note">
            お客様ご自身でお預け・お受け取りいただける拠点の一覧です。ロッカーは24時間、<b>店頭のみの拠点は営業時間内に限られます</b>。配達手数料はかかりません。
          </div>
          <table className="sg-table">
            <thead>
              <tr><th>拠点</th><th>担当店</th><th>セルフ預入れ</th></tr>
            </thead>
            <tbody>
              {SELF_SPOTS.map((s) => (
                <tr key={s.name}>
                  <td>
                    {s.name}
                    {s.lat && (
                      <small>
                        <a href={navUrl(s.lat, s.lon)} target="_blank" rel="noreferrer">
                          🧭 Googleマップでナビを開く
                        </a>
                      </small>
                    )}
                  </td>
                  <td>{s.company}</td>
                  <td>{typeLabel(s)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="sg-callout">
            <b>セルフでのお受け取りで300円クーポン</b>
            ロッカー・店頭でお受け取りいただくと、次回使える300円クーポンをプレゼントしています。
          </div>
          <Link to="/self_guide" className="sg-btn-next">はじめてのセルフ利用ガイドを見る</Link>
        </div>
      </div>
    </div>
  );
};
